import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import LazyImage from '../ui/LazyImage';

const About = () => {
  const workExperience = [
    {
      company: 'S.M Soni infosoft',
      position: 'Dotnet Developer Intern',
      period: 'Apr 2022 - Jun 2022 · 3 mos',
      location: 'Vadodara, Gujarat, India · On-site',
      logo: require('../../assets/optimized/S.M_soni-infosoft.jpg'),
      webpLogo: require('../../assets/optimized/S.M_soni-infosoft.webp')
    },
    {
      company: 'DEC Gaming Studio',
      position: 'Full Stack Developer intern',
      period: 'Apr 2025 - july 2025 · 4 mos',
       location: 'Vadodara, Gujarat, India · hybrid',
      logo: require('../../assets/optimized/DECGamingStudioLogo.jpg'),
      webpLogo: require('../../assets/optimized/DECGamingStudioLogo.webp')
    }
  ];

  const education = [
    
    {
      institution: 'Parul University',
      degree: "Bachelor of technology in Computer Science & Engineering",
      period: '2023 - 2026',
      logo: require('../../assets/optimized/ParulUniversityPost.jpg'),
      webpLogo: require('../../assets/optimized/ParulUniversityPost.webp')
    },
    {
      institution: 'Parul University',
      degree: "Diploma in Computer Science & Engineering",
      period: '2020 - 2023',
      logo: require('../../assets/optimized/ParulUniversityPost.jpg'),
      webpLogo: require('../../assets/optimized/ParulUniversityPost.webp')
    },
    {
      institution: 'Baroda Public School',
      degree: 'Schooling',
      period: '2011 - 2020',
      logo: require('../../assets/optimized/bps.jpg'),
      webpLogo: require('../../assets/optimized/bps.webp')
    }
  ];

  const skills = [
    'React', 'TypeScript', 'Node.js', 'Python', 
    'PostgreSQL', 'Docker', 'Java'
  ];

  return (
    <div className="min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          
          {/* Left Side - Profile Section */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            {/* Profile Image */}
            <div className="mb-8">
              <LazyImage
                src={require('../../assets/optimized/pfp.jpg')}
                webpSrc={require('../../assets/optimized/pfp.webp')}
                alt="Profile"
                className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 rounded-full object-cover border-4 border-gray-600"
                placeholder="bg-gray-600 animate-pulse rounded-full"
              />
            </div>
            
            {/* Name and Title */}
            <div className="mb-8">
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4 font-sf">
                Hi, I'm Dev 
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed max-w-md">
                I’m an engineer who likes building and experimenting with new ideas. You’ll catch me sharing what I’m working on here.
              </p>
            </div>

            {/* About Description */}
            <div className="text-gray-400 leading-relaxed max-w-md">
              <h3 className="text-2xl font-bold text-white mb-4">About Me</h3>
              <p className="mb-6">
              I'm a CSE student who loves turning ideas into real projects. Over time, I've built everything from AI chatbots to full-stack apps and explored the world of cloud and DevOps. I've also{' '}
              <span className="text-white font-semibold underline">competed in multiple hackathons</span>,{' '}
              <span className="text-white font-semibold underline">worked on innovative student projects</span>, and{' '}
              <span className="text-white font-semibold underline">keep learning how to blend tech with real-world impact</span>.
              </p>
              
              {/* Social Media Links */}
              <div className="flex space-x-4">
                <a 
                  href="https://github.com/DevxD98" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 bg-opacity-50 rounded-full flex items-center justify-center border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-300"
                >
                  <FaGithub className="text-gray-300 text-lg" />
                </a>
                <a 
                  href="https://linkedin.com/in/dev-mondal-497986223/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 bg-opacity-50 rounded-full flex items-center justify-center border border-gray-600 hover:bg-blue-600 hover:border-blue-500 transition-all duration-300"
                >
                  <FaLinkedin className="text-gray-300 text-lg hover:text-white" />
                </a>
              </div>
            </div>
          </div>

          {/* Right Side - Experience, Education, Skills */}
          <div className="space-y-12">
            
            {/* Work Experience Section */}
            <div className="bg-black bg-opacity-50 backdrop-blur-md rounded-xl p-6 border border-gray-700">
              <h3 className="text-2xl font-bold text-white mb-6">Work Experience</h3>
              <div className="space-y-6">
                {workExperience.map((job, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-600 flex-shrink-0">
                      <LazyImage
                        src={job.logo}
                        webpSrc={job.webpLogo}
                        alt={job.company}
                        className="w-full h-full object-cover"
                        placeholder="bg-gray-600 animate-pulse"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div>
                          <h4 className="text-lg font-semibold text-white">{job.company}</h4>
                          <p className="text-gray-400">{job.position}</p>
                          {job.location && (
                            <p className="text-gray-500 text-sm">{job.location}</p>
                          )}
                        </div>
                        <span className="text-sm text-gray-500 mt-1 sm:mt-0">{job.period}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Education Section */}
            <div className="bg-black bg-opacity-50 backdrop-blur-md rounded-xl p-6 border border-gray-700">
              <h3 className="text-2xl font-bold text-white mb-6">Education</h3>
              <div className="space-y-6">
                {education.map((edu, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-600 flex-shrink-0">
                      <LazyImage
                        src={edu.logo}
                        webpSrc={edu.webpLogo}
                        alt={edu.institution}
                        className="w-full h-full object-cover"
                        placeholder="bg-gray-600 animate-pulse"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between">
                        <div className="flex-1 min-w-0">
                          <h4 className="text-lg font-semibold text-white">{edu.institution}</h4>
                          <p className="text-gray-400 text-sm leading-relaxed">{edu.degree}</p>
                        </div>
                        <span className="text-sm text-gray-500 mt-1 lg:mt-0 lg:ml-4 whitespace-nowrap">{edu.period}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Skills Section */}
            <div className="bg-black bg-opacity-50 backdrop-blur-md rounded-xl p-6 border border-gray-700">
              <h3 className="text-2xl font-bold text-white mb-6">Skills</h3>
              <div className="flex flex-wrap gap-3">
                {skills.map((skill, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-gray-800 text-gray-300 rounded-full text-sm font-medium border border-gray-600 hover:bg-gray-700 transition-colors"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;